import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: true,
})
export class SortByPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    array.sort(function (a, b) {
      const aField = a[field].toUpperCase();
      const bField = b[field].toUpperCase();
      return aField.localeCompare(bField);
    });
    return array;
  }
}
